import styled from "styled-components";

export const PaymentWrapper = styled.div`
  grid-area: Payment;
  /* border: 1px solid black; */
`;
export const ContentConatiner = styled.div`
  /* border: 1px solid black; */
  display: flex;
 
  padding : 2rem 20px ;
  align-items : center;
  border-bottom : 2px solid #eee;
  margin-bottom : 40px;
`;
export const ContentCircle =styled.div`
width: 50px;
height: 50px;

border-radius: 50%;
margin-right: 1rem;
img{
    width: inherit;
    
   box-sizing: border-box;
}
`
export const ContentTitle = styled.div`
  /* border: 1px solid black; */
  text-align : left;
  font-size : 14px;
  flex :1;
  span{
    font-weight: 800;
    color : #90d6d6;
  }
`;
export const RefuntOrCancle = styled.div`
 
  div{
    color : #fff;
    cursor: pointer;
  background : #8bc541;
  border : 1px solid #8bc541;
  padding : 6px 25px;
  font-size : 12px;
  border-radius : 4px;
  }
  &:hover{
    /* background : # */
  }
`